module.exports = __webpack_public_path__ + "static/media/cgs_trustit_fr.38008ac0.pdf";